import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { Pagination } from "@/types";
import { GetWorkspaceInvitesParams, WorkspaceInvite } from "@/types/workspace-invite";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useGetWorkspaceInvites = (params?: GetWorkspaceInvitesParams) => {
  const userToken = useUserToken();
  const url = new URL(ENDPOINTS.workspace_invites);
  if (params?.invitee_email) {
    url.searchParams.append("invitee_email", params.invitee_email);
  }
  if (params?.workspace_id) {
    url.searchParams.append("workspace_id", params.workspace_id.toString());
  }
  if (params?.status) {
    url.searchParams.append("status", params.status);
  }
  if (params?.organization_id) {
    url.searchParams.append("organization_id", params.organization_id.toString());
  }

  url.searchParams.append("per_page", params?.perPage?.toString() ?? "100");
  url.searchParams.append("page", params?.page?.toString() ?? "1");

  return useQuery(
    [ENDPOINTS.workspace_invites, params],
    (): Promise<Pagination<WorkspaceInvite>> =>
      fetch(url, {
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    {
      retry: false,
      enabled: !!params?.invitee_email || !!params?.workspace_id || !!params?.organization_id,
    },
  );
};
